export const skills = [
  {
    id: '6a97871e-b809-4d55-b4c5-2c7e9a02a055',
    value: 'haircuts',
    name: 'Haircuts',
    type: 'predefined',
  },
  {
    id: 'aa303d33-284e-4d18-bbc7-6f33932ae102',
    value: 'coloring',
    name: 'Coloring',
    type: 'predefined',
  },
  {
    id: '24cb6d9a-3a55-4ccf-a927-4ab140e8d3cb',
    value: 'highlights',
    name: 'Highlights',
    type: 'predefined',
  },
  {
    id: '01209615-2066-412d-8d5c-ae4dd7b795e0',
    value: 'perms',
    name: 'Perms',
    type: 'predefined',
  },
  {
    id: '94593643-ba87-47e5-ae0c-5c445aa46168',
    value: 'blowouts',
    name: 'Blowouts',
    type: 'predefined',
  },
  {
    id: 'c186401e-8c39-4fd6-aedd-14d972841045',
    value: 'braiding',
    name: 'Braiding',
    type: 'predefined',
  },
  {
    id: '856bca76-ffc3-44cf-b0a2-d71c73d19046',
    value: 'extensions',
    name: 'Extensions',
    type: 'predefined',
  },
  {
    id: '4598624c-b7b7-41e7-bc77-309f588ab14e',
    value: 'makeup',
    name: 'Makeup',
    type: 'predefined',
  },
  {
    id: '078863fa-72db-461c-9bac-8ab154bea06e',
    value: 'waxing',
    name: 'Waxing',
    type: 'predefined',
  },
  {
    id: '58433e65-9556-4cfe-91a0-ab7f91627db9',
    value: 'facials',
    name: 'Facials',
    type: 'predefined',
  },
  {
    id: 'cbac63bd-78a6-4ecf-aab5-e7ab489e6ddf',
    value: 'massage',
    name: 'Massage',
    type: 'predefined',
  },
  {
    id: '3c7ae57d-d72a-4038-97dc-89cacf66e380',
    value: 'manicure',
    name: 'Manicure',
    type: 'predefined',
  },
  {
    id: '61259670-bf37-438b-b90a-7b88e0eaa7a0',
    value: 'pedicure',
    name: 'Pedicure',
    type: 'predefined',
  },
  {
    id: '43b6c5cf-ca92-4b57-9032-0d113a359e8b',
    value: 'tattoos',
    name: 'Tattoos',
    type: 'predefined',
  },
  {
    id: '114a3e59-7353-4b57-ba72-4a40244bacd9',
    value: 'piercings',
    name: 'Piercings',
    type: 'predefined',
  },
  {
    id: 'daf12261-ec60-40ae-b89e-c37164bd841e',
    value: 'teamwork',
    name: 'Teamwork',
    type: 'predefined',
  },
  {
    id: 'bc53d21f-09cd-4541-af4c-d468f0393de2',
    value: 'communication',
    name: 'Communication',
    type: 'predefined',
  },
  {
    id: 'f77b253d-3091-4277-bc3e-3cc78f8d3c4f',
    value: 'adaptability',
    name: 'Adaptability',
    type: 'predefined',
  },
  {
    id: 'e231b212-9820-4313-9512-78a4ad1e9239',
    value: 'leadership',
    name: 'Leadership',
    type: 'predefined',
  },
  {
    id: 'caf2bd50-92eb-4e86-a673-b6ef20ff050d',
    value: 'time_management',
    name: 'Time Management',
    type: 'predefined',
  },
  {
    id: '44dd8bb3-a1ea-4f77-9c15-33e64e6489da',
    value: 'attention_to_detail',
    name: 'Attention to detail',
    type: 'predefined',
  },
  {
    id: '136917b7-c96a-4a75-8433-a9a90672ed05',
    value: 'hygiene_and_safety',
    name: 'Hygiene and Safety',
    type: 'predefined',
  },
  {
    id: '01f2ef46-afa9-457b-8b4a-aa232988f408',
    value: 'creativity',
    name: 'Creativity',
    type: 'predefined',
  },
  {
    id: 'ec7403d3-1ae3-4eb2-b7c5-509666d303df',
    value: 'product_knowledge',
    name: 'Product knowledge',
    type: 'predefined',
  },
  {
    id: 'ee41ca54-8b58-4425-a7df-6fcb770a502c',
    value: 'physical_stamina',
    name: 'Physical stamina',
    type: 'predefined',
  },
  {
    id: 'ed6bbf71-f29c-4676-95d4-c69d5e906ac4',
    value: 'anatomy_and_physiology_knowledge',
    name: 'Anatomy and physiology knowledge',
    type: 'predefined',
  },
  {
    id: '5b0e72fd-27ff-44cc-af62-99b3fff82eb7',
    value: 'empathy_and_compassion',
    name: 'Empathy and compassion',
    type: 'predefined',
  },
  {
    id: 'a205d78e-1c6f-421c-a658-d8f9dbbd9f3e',
    value: 'nails',
    name: 'Nails',
    type: 'predefined',
  },
]

export const jobRoles = [
  {name: 'Hairstylist', value: 'hairstylist'},
  {name: 'Manager', value: 'manager'},
  {name: 'Barber', value: 'barber'},
  {name: 'Receptionist', value: 'receptionist'},
  {name: 'Assistant Stylist', value: 'assistant_stylist'},
  {name: 'Cosmetologist', value: 'cosmetologist'},
  {name: 'Aesthetician', value: 'aesthetician'},
  {name: 'Nail Technician', value: 'nail_technician'},
  {name: 'Massage Therapist', value: 'massage_therapist'},
  {name: 'Tattoo Artist', value: 'tattoo_artist'},
  {name: 'Photographer', value: 'photographer'},
  {name: 'Makeup Artist', value: 'makeup_artist'},
  {name: 'Assistant Hairstylist', value: 'assistant_hairstylist'},
  {name: 'Assistant Tattoo Artist', value: 'assistant_tattoo_artist'},
  {name: 'Assistant Photographer', value: 'assistant_photographer'},
  {name: 'Aesthethic Nurse', value: 'aesthetic_nurse'},
  {name: 'Aesthethic Injector', value: 'aesthetic_injector'},
  {name: 'Laser Technician', value: 'laser_technician'},
  {name: 'Spa Coordinator', value: 'spa_coordinator'},
  {name: 'Instructor', value: 'instructor'},
  {name: 'Vendor / Supplier', value: 'vendor'},
]

// Vendors sell to the industry; they don't teach classes or rent chairs, so
// class categories and space eligibility leave them out.
const VENDOR_ROLES = ['vendor']
export const classCategories = jobRoles.filter(
  (r) => !VENDOR_ROLES.includes(r.value)
)
export const spaceProfessions = classCategories

export const workTypes = [
  {name: 'Full Time', value: 'full_time'},
  {name: 'Part Time', value: 'part_time'},
  {name: 'Contract', value: 'contract'},
  {name: 'Rental', value: 'rental'},
  {name: 'Commission', value: 'commission'},
  {name: 'Apprenticeship', value: 'apprenticeship'},
  {name: 'Gig Work', value: 'gig_work'},
]

export const compensationTypes = [
  'hourly',
  'weekly',
  'monthly',
  'booth_rental',
  'salary',
]

export const skillLevels = [
  {name: 'Beginner', value: 'beginner'},
  {name: 'Intermediate', value: 'intermediate'},
  {name: 'Advanced', value: 'advanced'},
  {name: 'Expert', value: 'expert'},
  {name: 'All Levels', value: 'all-levels'},
]

export const businessTypes = [
  {name: 'Hair Salon', value: 'hair_salon'},
  {name: 'Tattoo Shop', value: 'tattoo_shop'},
  {name: 'Spa', value: 'spa'},
  {name: 'MedSpa', value: 'med_spa'},
  {name: 'Nail Salon', value: 'nail_salon'},
  {name: 'Barber Shop', value: 'barber_shop'},
  {name: 'Wholesale/Vendor', value: 'wholesale_vendor'},
  {name: 'Business', value: 'studio'},
  {name: 'Sales Representative', value: 'sales_representative'},
  {name: 'Photo Business', value: 'photo_studio'},
]

export const businessServices = [
  'haircuts',
  'coloring',
  'highlights',
  'perms',
  'blowouts',
  'braiding',
  'extensions',
  'makeup',
  'waxing',
  'facials',
  'massage',
  'manicure',
  'pedicure',
  'tattoos',
  'piercings',
  'nails',
  'photography',
]

export const daysOfWeek = [
  {short: 'Monday', full: 'monday'},
  {short: 'Tuesday', full: 'tuesday'},
  {short: 'Wednesday', full: 'wednesday'},
  {short: 'Thursday', full: 'thursday'},
  {short: 'Friday', full: 'friday'},
  {short: 'Saturday', full: 'saturday'},
  {short: 'Sunday', full: 'sunday'},
]

export const defaultTimes = {
  Monday: {start: '09:00', end: '17:00', closed: false},
  Tuesday: {start: '09:00', end: '17:00', closed: false},
  Wednesday: {start: '09:00', end: '17:00', closed: false},
  Thursday: {start: '09:00', end: '17:00', closed: false},
  Friday: {start: '09:00', end: '17:00', closed: false},
  Saturday: {start: '09:00', end: '17:00', closed: true},
  Sunday: {start: '09:00', end: '17:00', closed: true},
}

export const supportedSocialLinks = [
  'facebook',
  'youtube',
  'tiktok',
  'instagram',
  'twitter',
  'x',
  'linkedin',
  'indeed',
]
